import React from 'react';
import { connect } from 'react-redux';

import { toggleChat } from 'apps/auth/actions/chatAction';
import { InfoPage } from 'apps/auth/components/common/Layout/InfoPage/InfoPage';
import ModalComponent from 'apps/auth/components/utils/ModalComponent';
import { usePageMessages } from 'apps/auth/hooks/selectors';

const DuplicatedRegistrationRestrictionModal = (props) => {
    const { notNowButton, contactSupport, registrationDuplicateTitle, registrationDuplicateInfo } = usePageMessages();
    return (
        <ModalComponent canCloseModal={false} isVerticalCentered>
            <InfoPage
                iconName="alert-circle-80"
                iconColor="primary"
                topButtonType="link"
                topButtonLink={props.url}
                topButtonCaption={notNowButton}
                primaryButtonType={'link'}
                headerText={registrationDuplicateTitle}
                secondaryText={registrationDuplicateInfo}
                primaryButtonCaption={contactSupport}
                primaryButtonOnClick={(e) => {
                    e.preventDefault();
                    props.toggleChat(true);
                }}
            />
        </ModalComponent>
    );
};
export default connect(null, { toggleChat })(DuplicatedRegistrationRestrictionModal);
